import { Serializable } from '../../core/models/serializable';
export class ServerValidationResult
  implements Serializable<ServerValidationResult>
{
  fromObject(obj: any): ServerValidationResult {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public isSuccess: boolean;
}
